import jQuery from 'jquery';

function initMembershipOptions() {
  var $ = jQuery;
  if ( $('body.page-membership-options').length ) {
    var $pricing = $('.pricing-modules');
    $('.sub-select-btn').click(function(event){
      var priceType = $(event.target).val();
      $pricing.removeClass('price-yearly price-monthly').addClass('price-'+priceType);
      // console.log('price type is now', priceType);
      $('.sub-select-btn').each(function() {
        $(this).toggleClass('inactive', this !== event.target);
      });
    });
  }
}

function initSearch() {
  if ( jQuery('#search-box').length ) {
    jQuery('.search-toggler').click(function() {
      jQuery('.search-toggler i').toggleClass('fa-search').toggleClass('fa-times');
      jQuery('#search-box').toggleClass('d-none');
      jQuery('.search-control').focus();
    });
  }
}

function initShuffle() {
  if ( jQuery('#shuffle').length ) {
    window.shuffleInstance = new window.Shuffle(document.getElementById('shuffle'), {
      itemSelector: '.grid__brick',
      sizer: '.sizer-element',
      filterMode: Shuffle.FilterMode.ANY
    });

    window.jQuery('#shuffle-filter a').click(function (event) {
      event.preventDefault();
      var elm = event.currentTarget;

      jQuery('#shuffle-filter div').toggleClass('active',false);

      if ( jQuery(elm).data("category") !== undefined ) {
        window.shuffleInstance.filter(jQuery(elm).data("category"));
        jQuery(elm).parent().toggleClass('active',true);
      }
    });
  }
}

function initContactUsForm() {
  if ( jQuery('#contact-us-form').length ) {

    // On "Learn More" click, scroll down to form
    jQuery("a[href='#learnmore']").on('click', function (event) {
      event.preventDefault();
      var w = jQuery('body').width();
      jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery("a[name='learnmore']").offset().top - (w > 575 ? 0 : 64)
      }, 1000);
    });

    jQuery('#contact-us-form').submit(function(event) {
      event.preventDefault();
      
      jQuery.ajax({
        method: 'POST',
        url: '/php/contact.php',
        data: jQuery(this).serialize()
      })
      .done(function(data) {
        // toggle submit button back to a normal state
        if ( jQuery('#submit-button').length ) { jQuery('#submit-button').toggleClass('disabled'); }       
        
        if ( data.indexOf('success') != -1 ) {
          // jQuery(this).trigger("reset"); // reset for next use
          window.location.href = '/confirmation-request-to-learn-more/';
        }

        if ( jQuery('#form-result').length ) {
          jQuery('#form-result').html(data).show();
        }
      })
      .fail(function(data) {
        if ( jQuery('#form-result').length ) {
          jQuery('#form-result').html('<div class="alert alert-danger align-center">Error communicating with server, please try again later.</div>');
        }

        console.log(data);
      });
    });
  }
}


export default {
  init() {
    // JavaScript to be fired on all pages
    initShuffle();
    initSearch();
    initMembershipOptions();
    initContactUsForm();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
